module.exports = __webpack_public_path__ + "static/geir-e01799fbe2cf7f7dd18e61edf639a692.png";